import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-modal-sucesso',
  templateUrl: './modal-sucesso.component.html',
  styleUrls: ['./modal-sucesso.component.scss']
})
export class ModalSucessoComponent {

  @Input() confirmFunc: Function;
  @Input() successTitle: string;
  @Input() successMessage: string;

  public displayModal = false;

  public openDialog() {
    this.displayModal = true;
  }

  public closeDialog() {
    this.displayModal = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/modal-sucesso/modal-sucesso.component.ts